<template>
    <div class="cart">
        <div id="cartOverlayHeader" class="bottom10"><b>Cart Contents</b></div>
        <div class="accSettingsForm">
          <table width="100%" class="bottom10">
              <tr class="top10 has-text-weight-bold" >
                  <td width="40%" class="has-text-warning">Item</td>
                  <td width="30%" class="has-text-warning">Plan</td>
                  <td width="20%" class="has-text-right has-text-warning">Amount</td>
                  <td width="10%" class="has-text-centered ">&nbsp;</td>
              </tr>
  
              <tr v-for="(item, index) in this.$root.cartContents" :key="item.id" :class="{'tableDarkRow': ((index + 1) % 2) && ($route.fullPath == '/checkout' || $route.fullPath == '/checkout/')}">
                  <td><span class="has-text-grey-light has-text-weight-bold">&raquo;</span>{{item.slink | itemFilter}}</td>
                  <td class="cartHoverLink" @click="editPlan(item.slink, item.code, item.cartItemId)">{{item.type | theType(item.code)}}</td>
                  <td class="has-text-right">${{az.formatCurrency(item.price)}}</td>
                  <td class="has-text-centered"><span class="delete has-background-grey is-small top5" @click="$root.removeFromCart({key: 'slink', value: item.slink })"></span></td>
              </tr>
  
              <tr class="top10 has-text-weight-bold" >
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td class="topLine has-text-right">${{total}}</td>
                  <td>&nbsp;</td>
              </tr>
          </table>
        </div>
              <hr>
              <div class="is-pulled-left top-20 is-size-7">*Cart Items older than 1 hour will be automatically removed from cart. Complete your tranasction soon.</div>
        </div>
</template>

<script>
import { AZEventBus } from './AZEventBus.js';
import constants from '../STATIC/constants'
export default {
  data(){
    return {
        az: az
      };
  },
  computed: {
    total: function () {
      var temp = 0
      for (var i = 0; i < this.$root.cartContents.length; i++) {
        temp += Number(this.$root.cartContents[i].price)
      }
      return az.numeral(temp).format('0,000.00')
    }
  },
  methods: {
    editPlan: function(slink, code, itemId){
      this.$root.doShowModal('PlanChooser', {item: {type: 'slink', slink: slink}, isEdit: true, code: code, itemId: itemId})
    }
  },
  mounted: function () {
    const self = this
    
    self.worked = function (data) {
      az.addRemSpinner(false, 'class', 'cart');
      data.cart.Items.sort(function (a, b) {
        return new Date(a.createDate) - new Date(b.createDate)
      })
      self.$root.cartContents = data.cart.Items

      self.$root.setTmOffset(data.tm);

      function setItemTimer(inst, timeout, slink){
          setTimeout(
            () => {
              let ind = self.$root.cartContents.findIndex(e => {
                return e.cartItemId == inst
              })
              if(ind != -1){
                self.$root.cartContents.splice(ind, 1)
                self.$notify({
                  title: 'Alert',
                  text: 'The following cart item has expired and has been removed: ' + slink,
                  type: 'warn',
                  duration: -1
                })
                //clear api cache for this slink 
				        //self.$root.apiClient.get('api/slink/' + slink, {}, function(){}, function(){}, null, {'Cache-Control': 'max-age=0'})
                self.$root.clearSlinkCache(slink)
              }
            }, timeout
          )
      }

      self.$root.cartContents.forEach(e => {

        let d = new Date().getTime()/1000|0
        let actTime = d - self.$root.timeOffset
        let rem = e.cartItemTTL - actTime
        if(rem > 0){
          setItemTimer(e.cartItemId, rem * 1000, e.slink)

       
        }
        
      })
     
    }

    self.noWorked = function () {
      az.addRemSpinner(false, 'class', 'cart');
      self.$root.showModalOK({message: 'There was en arror loading cart contents. Please try again.'})
    }

    function init(){
      var cartID = az.getCookie('SlinkCartID');
      if(cartID != undefined && cartID != ''){
        az.addRemSpinner(true, 'class', 'cart');
        self.$root.apiClient.get('api/cart', {}, self.worked, self.noWorked, null, {'cart-user-id': cartID});
      }
    }

    if(self.$root.doneFederating){
      init();
    }

    AZEventBus.$once('onFederate', msg => {
      init();
    });

    
  },
  filters:{
    theType:  function(val, code){
      if(val == 'subPack'){
        return 'SubPack'
      } else if(val == 'trialconv'){
        return 'slink'
      } else if(val == 'slink'){
        return constants.plans[code].shortCode
      }
    },
    itemFilter: function(val){
      let arr = val.split('|')
      if(arr.length > 1 && arr[1] != 'conversion'){
        return "Subpack for '" + arr[0] + "'"
      } else if(arr[1] == 'conversion'){
        return arr[0]
      } else {
        return val
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cart.vue